import request from 'tools/request'
import { IEldVisibilityResponse, IAvailableEldResponse } from 'interfaces/IEldVisibility'

const getEldVisibilityList = async (): Promise<IEldVisibilityResponse> => {
  const { data } = await request.get<IEldVisibilityResponse>(
    `${process.env.REACT_APP_CARRIER_API_URL}eldvisibility`
  )
  return data
}

const getAvailableEldList = async (): Promise<IAvailableEldResponse> => {
  const { data } = await request.get<IAvailableEldResponse>(
    `${process.env.REACT_APP_CARRIER_API_URL}eldvisibility/available`
  )
  return data
}

const deleteEldVisibility = async (eldIds: number[]): Promise<IEldVisibilityResponse> => {
  const { data } = await request.delete<IEldVisibilityResponse>(
    `${process.env.REACT_APP_CARRIER_API_URL}eldvisibility`,
    {
      data: eldIds
    }
  )
  return data
}

const addEldVisibility = async (eldIds: number[]): Promise<IEldVisibilityResponse> => {
  const { data } = await request.post<IEldVisibilityResponse>(
    `${process.env.REACT_APP_CARRIER_API_URL}eldvisibility`,
    eldIds
  )
  return data
}

export {
  getEldVisibilityList,
  getAvailableEldList,
  deleteEldVisibility,
  addEldVisibility,
} 